import { Button, Grid } from "@mui/material";
import React from "react";
import { MDTypography } from "../MDTypography";
import { IMultiSelectOptions, MultiSelect } from "../MultiSelect/MultiSelect";

interface IProps {
  dropdowns: Array<IDropdownOption>;
  enableResetFilter?: boolean;
  resetChartFilters?: any;
}

interface IDropdownOption {
  label: string;
  options: Array<IMultiSelectOptions>;
  selected: Array<IMultiSelectOptions>;
  onChange: (newList: Array<IMultiSelectOptions>) => void;
}

export const ChartFilter: React.FC<IProps> = (props: IProps) => {
  return (
    <>
      <Grid container spacing={1}>
        {props.dropdowns.map((opt: IDropdownOption, index: number) => {
          return (
            <>
              <Grid item xs={4} key={`lbl-filter-${index}`}>
                <MDTypography variant="button" component='div'>{opt.label}</MDTypography>
              </Grid>
              <Grid item xs={8} key={`filter-ctrl-${index}`}>
              <MultiSelect
                    optionsList={(opt.options || []).map((item) => {
                      return { label: item.label, value: item.value };
                    })}
                    selectedList={opt.selected}
                    onChangeEvent={(checkedItems: any, list: any) => {
                      opt.onChange(list);
                    }}
                  />
              </Grid>
            </>
          );
        })}
        {props.enableResetFilter && (
          <Grid justifyContent="end" container mt={1} spacing={1}>
            <Grid item>
              <Button variant="contained" component="span" onClick={() => { props.resetChartFilters() }} >
                Reset Filters
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>

    </>
  );
};
